import * as yup from 'yup';

const validationSchema = yup.object().shape<formSchemaType>({
  email: yup
    .string()
    .email('Email inválido')
    .required('Email é um campo obrigatório'),
  password: yup.string().required('Senha é um campo obrigatório'),
});

export type formSchemaType = { email: string; password: string };

export default validationSchema;
